import {ReactNode} from "react"
import clsx from "clsx"

type Props = {
    children: ReactNode
    active?: boolean
    onClick?: () => void
}

export const TabButton = ({children, active, onClick}: Props) => (
    <button
        onClick={onClick}
        className={clsx(
            "px-4 py-2 rounded-xl text-sm font-medium transition",
            active
                ? "bg-emerald-500 text-white shadow-sm"
                : "bg-gray-100 text-gray-600 hover:bg-gray-200"
        )}
    >
        {children}
    </button>
)
